@let defaultRowHeight = defaultRowHeight$ | async;
@let resourcesColumnWidthPx = resourcesColumnWidthPx$ | async;

@if (
  {
    isMoveMode: dragAndDropModeService.isMoveMode$ | async,
    draggingShift: dragAndDropModeService.draggingShiftV2$ | async,
    draggingAbsence: dragAndDropModeService.draggingAbsence$ | async,
    frameLength: frameLength$ | async,
    timeframe: timeframe$ | async,
    publicHolidaysRegion: publicHolidaysRegion$ | async,
    rowHoverIndex: timelineInteractionService.hoveredRowIndex$ | async,
  };
  as timelineData
) {
  @if (timelineData.isMoveMode && timelineData.draggingShift) {
    <wilson-move-shift-drop-zone-v2></wilson-move-shift-drop-zone-v2>
  }
  @if (timelineData.isMoveMode && timelineData.draggingAbsence) {
    <wilson-move-absence-drop-zone></wilson-move-absence-drop-zone>
  }
  <wilson-dates-demarcator-lines
    [leftMarginPx]="resourcesColumnWidthPx || 0"
    [panelWidth]="timelineData.frameLength || 0"
    [interval]="timelineData.timeframe"
    [holidayRegions]="publicHolidaysRegion$ | async"
    [visibleDaysRange]="visibleDaysRange$ | async"
  ></wilson-dates-demarcator-lines>
  <div [style.height.px]="rowHeightWithBorder * (fullUserLength || 0)">
    @let trimmedUserList = (trimmedUserList$ | async) || [];
    @let visibleUserIdsSet =
      assignedRegionVisibilityStateService.visibleUserIdsSet$ | async;
    @for (user of trimmedUserList; track trackById(i, user); let i = $index) {
      @let isUserVisible = visibleUserIdsSet?.has(user.id!);
      @if (isUserVisible) {
        @if (
          {
            determinedUserData: (user.id! | toUserDataV2 | async),
          };
          as data
        ) {
          @if (data.determinedUserData) {
            @if (
              {
                isTimeIndicatorVisible:
                  dragAndDropModeService.isTimeIndicatorsVisible$ | async,
                isHovered: i === timelineData.rowHoverIndex,
              };
              as overlapData
            ) {
              @if (
                timelineData.isMoveMode &&
                overlapData.isHovered &&
                overlapData.isTimeIndicatorVisible
              ) {
                <div>
                  <wilson-timeline-shift-time-tag
                    [resourcesColumnWidthPx]="resourcesColumnWidthPx ?? 0"
                  ></wilson-timeline-shift-time-tag>
                </div>
              }
              <div class="d-flex">
                <div
                  id="left-container"
                  class="sticky"
                  [class.hover]="overlapData.isHovered"
                  [style.border-bottom-width.px]="ROW_BORDER_BOTTOM_PX"
                >
                  <div
                    id="left-block"
                    [style.width.px]="resourcesColumnWidthPx"
                  >
                    <wilson-user-timelines-info-card
                      [index]="i"
                      [user]="user"
                    ></wilson-user-timelines-info-card>
                  </div>
                </div>
                <div
                  id="right-container"
                  class="timeline-container"
                  [style.width.px]="timelineData.frameLength"
                >
                  <div id="right-block" class="timeline-block">
                    <div class="items-container">
                      <div
                        class="item"
                        [class.hover]="overlapData.isHovered"
                        (mouseenter)="
                          timelineInteractionService.setHoveredRowIndex(i)
                        "
                      >
                        <wilson-timeline-user-row-shifts-v2
                          [user]="user"
                          [userIndex]="i"
                          [userDataRowsData]="data.determinedUserData"
                          [defaultRowHeight]="defaultRowHeight"
                          [mouseOverRowIndex]="timelineData.rowHoverIndex"
                        ></wilson-timeline-user-row-shifts-v2>
                      </div>
                    </div>
                    @defer {
                      @if (isUserVisible && !overlapData.isHovered) {
                        <wilson-weekend-holiday-highlighter
                          [data]="weekendHolidayRenderData"
                        ></wilson-weekend-holiday-highlighter>
                      }
                    }
                  </div>
                </div>
              </div>
            }
          }
        }
      } @else {
        <div [style.height.px]="rowHeightWithBorder"></div>
      }
    }
  </div>
}
